import React from 'react';

const FooterStrip = () => (
   <div className="text-center bg-black w-full text-gray-400 p-2 mt-4">
      © Ethan Loch
   </div>
);

export default FooterStrip;